module.exports = require('./helpers/bundle-url').getBundleURL('6FqWr') + "pipelines-promotion-icon.dd3d5818.png";